import Emitter from "./Emitter";

export default class OpenTable extends Emitter {
    constructor(gb) {
        super(gb);
    }

    _default(data) {
        this.emitTop({ wpgaction: "open-table", param: { game_id: data.game_id || null, game_name: data.game_name || null, table_id: data.table_id || null, limit_id: data.limit_id || null, uiGameName: data.uiGameName || null } });
        this.emitParent({ wpgaction: "open-table.parent", param: { game_id: data.game_id || null, game_name: data.game_name || null, table_id: data.table_id || null, limit_id: data.limit_id || null, uiGameName: data.uiGameName || null } });
    }
}
